import { useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { ListPagination, paginate } from "@/components/list-pagination";
import { Item, ItemContent, ItemDescription, ItemTitle } from "@/components/ui/item";
import { resellersQuery } from "@/features/staff/queries";
import { ResellerList } from "@/features/staff/reseller-list";
import { mayDecideApplications } from "@/features/staff/roles";
import { m } from "@/lib/paraglide/messages.js";

const PAGE_SIZE = 10;

// ?page= is route state (guide, rule 16): a link to page 2 opens page 2. Anything else reads as 1.
const HomeSearch = z.object({
  page: z.coerce.number().int().min(1).optional().catch(undefined),
});

// /staff: the queue. Today that is the reseller applications waiting for a decision (top-ups and
// documents join it once their slices exist); compliance and superadmin decide them here.
export const Route = createFileRoute("/staff/_authenticated/")({
  validateSearch: HomeSearch,
  loader: ({ context }) => context.queryClient.ensureQueryData(resellersQuery()),
  component: StaffHome,
});

function StaffHome() {
  const { staffMember } = Route.useRouteContext();
  const { page: asked = 1 } = Route.useSearch();
  const { data: resellers } = useSuspenseQuery(resellersQuery());
  const { page, pages, items, range } = paginate(resellers, asked, PAGE_SIZE);
  return (
    <>
      <Item>
        <ItemContent>
          <ItemTitle>{m.staff_home_welcome({ name: staffMember.name })}</ItemTitle>
          <ItemDescription>{m.staff_resellers_description()}</ItemDescription>
        </ItemContent>
      </Item>
      <ResellerList
        resellers={items}
        caption={range}
        pagination={<ListPagination page={page} pages={pages} />}
        canDecide={mayDecideApplications(staffMember.role)}
      />
    </>
  );
}
